import React from "react";
import Img from "react-image";
import _ from "lodash";
import { connect } from "react-redux";
import srcIconCheck from "../../../../../../styles/img/icon-check-white.svg";
import moment from "moment";
import {
  postMessageSimple,
  postMessageMulti,
} from "../les-tabs-ducks/Message.ducks";

const IconCheckWhite = () => <Img src={srcIconCheck} className="img-fluid" />;
moment.locale("fr");

function notEmpty(value) {
  return !_.isEmpty(value);
}

class Message extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      objetMessage: "",
      readySubmit: false,
      show: false,
      checkTextarea: "",
      opacity: { opacity: 0.25, pointerEvents: "none" },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.myChangeHandler = this.myChangeHandler.bind(this);
  }

  toggle() {
    this.props.toggle();
    this.setState({ readySubmit: false, objetMessage: "" });
  }
  myChangeHandler = (event) => {
    this.setState({
      checkTextarea: event.target.value,
      opacity: { opacity: 1 },
    });
  };
  handleChange = (event) => {
    let name = event.target.name;
    let prevState = this.setState(
      {
        [name]: event.target.value,
        opacity: { opacity: 0.25, pointerEvents: "none" },
      },
      () => {
        let readySubmit = this.props.readySubmit;
        let tabSubmit;
        notEmpty(this.state.objetMessage)
          ? (tabSubmit = true)
          : (tabSubmit = false);
        if (tabSubmit && readySubmit === false) {
          this.props.handleReadySubmit();
        } else if (tabSubmit === false && readySubmit) {
          this.props.handleReadySubmit();
        }
      }
    );
    if (!(event.target.id === "autre-mess")) {
      this.setState({ opacity: { opacity: 1 } });
    }
    if (event.target.id === "autre-mess") {
      this.setState({ show: true });
    } else {
      this.setState({
        show: false,
      });
    }
  };

  handleSubmit(event) {
    event.preventDefault();

    if (this.props.submitMulti && notEmpty(this.state.objetMessage)) {
      let listIds = this.props.dataMulti.listChild;
      let data = {
        idsEnfants: listIds,
        message: {
          body: this.state.checkTextarea,
          type: this.state.objetMessage,
        },
      };
      this.props.postMessageMulti(localStorage.getItem("token"), data);
    } else if (
      notEmpty(this.props.kidItem) &&
      notEmpty(this.state.objetMessage)
    ) {
      let data = {
        body: this.state.checkTextarea,
        type: this.state.objetMessage,
      };
      this.props.postMessageSimple(
        localStorage.getItem("token"),
        this.props.kidItem.id,
        data
      );
    }
    this.props.handleSubmit();
  }

  render() {
    return (
      <div
        className="tab-pane  show active"
        id="message-pane"
        role="tabpanel"
        aria-labelledby="message-tab"
      >
        <div className="content">
          <h2>Sélectionnez un objet</h2>
          <div className="row mx-n2 mb-4 d-flex align-items-center justify-content-center objet-sante">
            <div className="col-md-4 px-2">
              <input
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="couches"
                value="COUCHE"
                name="objetMessage"
              />
              <label htmlFor="couches" className="couches">
                <span>Couches</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="lait"
                value="LAIT"
                name="objetMessage"
              />
              <label htmlFor="lait" className="lait">
                <span>Lait</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="vetements"
                value="VETEMENTS"
                name="objetMessage"
              />
              <label htmlFor="vetements" className="vetements">
                <span>Vêtements</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="eau"
                value="EAU"
                name="objetMessage"
              />
              <label htmlFor="eau" className="eau">
                <span>Eau</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="tetine"
                value="TETINE"
                name="objetMessage"
              />
              <label htmlFor="tetine" className="tetine">
                <span>Tétine</span>
              </label>
            </div>
            <div className="col-md-4 px-2">
              <input
                onChange={this.handleChange}
                type="radio"
                className="d-none"
                id="autre-mess"
                value="AUTRE"
                name="objetMessage"
              />
              <label htmlFor="autre-mess" className="autre-mess">
                <span>Autre</span>
              </label>
            </div>
          </div>
          {this.state.show ? (
            <div className="autre-etat-sante mt-3">
              <textarea
                className="box-shadow"
                value={this.state.checkTextarea}
                onChange={this.myChangeHandler}
              ></textarea>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="btn-gradient btn-valid"
            onClick={(event) =>
              this.handleSubmit(event, this.state.readySubmit)
            }
            style={this.state.opacity}
          >
            <IconCheckWhite /> Envoyer
          </button>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = { postMessageSimple, postMessageMulti };
const mapStateToProps = ({ modals }) => ({ modals });
const withStore = connect(mapStateToProps, mapDispatchToProps);
export default withStore(Message);
